import React from 'react'

export default function ErgonomyAnalysis({ className }) {
  return (
    <svg className={`${className}  w-8 h-8`} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 12C14.7091 12 16.5 10.2091 16.5 8C16.5 5.79086 14.7091 4 12.5 4C10.2909 4 8.5 5.79086 8.5 8C8.5 10.2091 10.2909 12 12.5 12Z" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.5 21V19C20.5 16.7909 18.7091 15 16.5 15H8.5C6.29086 15 4.5 16.7909 4.5 19V21" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
